// Basis-Title/-Description werden aus dem bereits vorhandenen <head> gelesen
// (entweder von der Trägerseite gesetzt, in die diese App eingebettet wird,
// oder vom Fallback in public/index.html), damit hier kein Firmen-/Marken-
// name hart codiert werden muss.
export const baseTitle = document.title || "";

const descriptionTag = document.querySelector('meta[name="description"]');
export const baseDescription = descriptionTag
    ? descriptionTag.getAttribute("content") || ""
    : "";

export function truncate(text, maxLength = 155) {
    if (!text || text.length <= maxLength) return text;
    return text.slice(0, maxLength - 1).trimEnd() + "…";
}
